/**
 * Banner 15 — Simple hero: full-bleed background image with a single overlaid
 * title (left aligned). Only the title text + color and the background image
 * are admin-driven. All values map onto existing shared `banner` columns, so
 * no new DB columns are required.
 */

export const BANNER_15_CONSTANTS = {
  BANNER_FIELDS_CONFIG: [
    {
      fieldName: "title",
      label: "Title",
      value: "",
      valueType: "string",
      filedType: "TEXTAREA",
      placeholder: "Heading shown over the background image",
      required: false,
      defaultValue: "",
      rows: 3,
    },
    {
      fieldName: "title_color",
      label: "Title color",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#FFFFFF",
      required: false,
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "image",
      label: "Desktop background image",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload desktop background image",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "mobile_image",
      label: "Mobile background image (optional)",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Falls back to the desktop image when empty",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "image_alt",
      label: "Background image alt text",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Describe the background image",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "background_color",
      label: "Section background color (fallback if no image)",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#FFFFFF",
      required: false,
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "status",
      label: "Section Status",
      value: true,
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder: "Enable/Disable Section",
      defaultValue: true,
    },
  ],
};
